import React, { FC } from 'react';

import { usePaymentContext } from 'features/payment';
import noop from 'lodash-es/noop';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { logAddPaymentMethodClick } from 'state/amplitude';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

export const AddGiftCardLink: FC<React.PropsWithChildren<{
  setIsAddGiftCardVisible?: (param: boolean) => void;
  setIsTransferGiftCardVisible?: (param: boolean) => void;
}>> = ({ setIsAddGiftCardVisible = noop, setIsTransferGiftCardVisible = noop }) => {
  const { getPrepaidPaymentMethod } = usePaymentContext();
  const hasGiftCard = !!getPrepaidPaymentMethod();

  const buttonText = hasGiftCard
    ? t('transferBalanceFromPrepaidCard', { cardAlias: t('cardAlias.bk') })
    : t('addNewPaymentMethodGiftCard');

  const setGiftCardModalVisible = hasGiftCard
    ? setIsTransferGiftCardVisible
    : setIsAddGiftCardVisible;
  if (setGiftCardModalVisible !== noop) {
    return (
      <ActionButton
        fullWidth
        variant={ActionButtonVariants.OUTLINE}
        onPress={() => {
          setGiftCardModalVisible(true);
          logAddPaymentMethodClick();
        }}
        testID={hasGiftCard ? 'transfer-gift-card' : 'add-new-gift-card'}
      >
        {buttonText}
      </ActionButton>
    );
  }

  return (
    <ActionButton
      fullWidth
      variant={ActionButtonVariants.OUTLINE}
      to={hasGiftCard ? routes.transferGiftCard : routes.addGiftCard}
      onPress={logAddPaymentMethodClick}
      testID={hasGiftCard ? 'transfer-gift-card' : 'add-new-gift-card'}
    >
      {buttonText}
    </ActionButton>
  );
};
